import { useNavigate } from 'react-router';
import { useLocation } from 'react-router';

import ListItem from '@mui/material/ListItem';
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

const SidebarItem = props => {
  const {
    icon,
    Icon,
    href = "",
    title = "",
    onClick,
    exactMatch = null
  } = props;

  const navigate = useNavigate();
  const location = useLocation();
  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      navigate(href);
    }
  };

  const isSelected = exactMatch
  ? location.pathname === href
      : location.pathname === href || location.pathname.startsWith(href + "/");
  return (
    <ListItem >
      <ListItemButton
        onClick={handleClick}
        selected={isSelected}
        sx={{
          "& .MuiListItemIcon-root": {
            color: "#CD9D41",
          },
          "&.Mui-selected": {
            backgroundColor: "#D6B9811C",
            color: "#CD9D41",
            "&:hover": {
              backgroundColor: "#D6B9811C"
            }
          }
        }}
      >
        <ListItemIcon>
          <img src={icon} style={{height:25}} alt={icon}/>
          {Icon}
        </ListItemIcon>
        <ListItemText primary={title} />
      </ListItemButton>
    </ListItem>
  );
};

export default SidebarItem;